export const POSITIONS_AMOUNT = 20
export const DEBOUNCE_DELAY = 1000
export const MILLISECONDS_IN_SECONDS = 1000
export const HUNDREDTHS = 2
export const HUNDRED = 100
export const REVIEW_TEXT_MIN_LENGTH = 70
export const MAX_COMMENT_LENGTH = 700
export const DIVIDE_BY_TWO = 2
export const PLAYLIST_MAX_LENGTH_NAME = 45
